{
      "repositories" : [
    {
        "branch":  "preview",
        "url":  "https://gitlab.cs.nl/cs/cohelion/demo/CohelionDemoAviation/tree/608858508c3b24d58da45525a596d969a8de1b53",
        "displayName":  "CDP",
        "tag":  "",
        "lastCommitHash":  "608858508c3b24d58da45525a596d969a8de1b53"
    },
    {
        "branch":  "HEAD",
        "url":  "https://teamcity_cs@gitlab.cs.nl/cs/cohelion/pm-core/tree/9782dde93fa9515ca3890c6c0edf42fe39f973ba",
        "displayName":  "pm-core",
        "tag":  "",
        "lastCommitHash":  "9782dde93fa9515ca3890c6c0edf42fe39f973ba"
    },
    {
        "branch":  "HEAD",
        "url":  "https://teamcity_cs@gitlab.cs.nl/cs/performancemanager/performance-manager-seed/tree/df07bc99db174a8d5f5440a2061195c2defabdf6",
        "displayName":  "cdp-client",
        "tag":  "",
        "lastCommitHash":  "df07bc99db174a8d5f5440a2061195c2defabdf6"
    }
],
      "buildDate"	: "2026-03-23T09:01+0100",
    "detailsUrl"	: "http://teamcity/buildConfiguration/Demo_Cdp_Aviation_Cdp_Preview/89500?buildTab=changes&showFiles=false&expandRevisionsSection=false",
    "version": "7.18.0",
    "libs": {
    "@cs/about":  "1.2.0",
    "@cs/assistant":  "1.7.7"
}
  }